import type { BranchPicks, StructuredPortrait } from '../types';

/** A portrait's follow-up answers as a list: portraits saved before several follow-ups existed hold a single object. */
export function portraitBranches(portrait: Pick<StructuredPortrait, 'branch_picks'>): BranchPicks[] {
  const picks = portrait.branch_picks;
  if (!picks) return [];
  return Array.isArray(picks) ? picks : [picks];
}
